export enum Notification {
  SHOW_NOTIFICATION = 'notification/set',
  CLOSE_NOTIFICATION = 'notification/close',
  RESET_NOTIFICATIONS = 'notification/reset',
}
